module.exports = __webpack_public_path__ + "img/line_img1.5ccce0d2.png";